import cx from 'classnames'
import { useRef, useState } from 'react'
import type { Components, Options } from 'react-markdown'
import Markdown from 'react-markdown'
import rehypeHighlight from 'rehype-highlight'
import gfm from 'remark-gfm'
import type { SwiperClass, SwiperRef } from 'swiper/react'
import { Swiper, SwiperSlide } from 'swiper/react'

import docSlides from '../../documentation'
import Pagination from '../Pagination'
import Link from './Link'
import classNames from './styles.module.scss'
import swiperConfig from './swiperConfig'


const rehypePlugins = [rehypeHighlight]
const components = { a: Link as unknown as Components['a'] }

interface IProps {
  onHide: () => void,
}

export default function InstructionCarosel({
  onHide,
}: IProps): JSX.Element {
  const slider = useRef<SwiperRef>(null)
  const [disabledButton, setDisabledButton] = useState<string | null>(null)
  const [pagination, setPagination] = useState<number[]>([])
  const [snapIndex, setSnapIndex] = useState<number>(0)

  const handleMoveMainSlider = (ind: number): void => {
    if(slider.current) {
      slider.current.swiper.slideTo(ind)
    }
  }

  const setButtonStatus: (swiper: SwiperClass) => void = (swiper) => {
    setPagination(swiper.snapGrid)
    setSnapIndex(swiper.snapIndex)
    if(swiper.activeIndex === slides.length - 1) {
      setDisabledButton('next')
      return
    } else if(swiper.activeIndex === 0) {
      setDisabledButton('prev')
      return
    }
    setDisabledButton(null)
  }

  const slides = docSlides.map((slide, ind) => (
    <SwiperSlide key={ind} data-test={`slide-${ind}`}>
      <div className={cx('markdown', classNames.markdown)}>
        <Markdown
          rehypePlugins={rehypePlugins as Options['rehypePlugins']}
          remarkPlugins={[gfm]}
          components={components}
        >
          {slide}
        </Markdown>
      </div>
    </SwiperSlide>
  ))

  return <div className={classNames.wrapper}>
    <Swiper
      {...swiperConfig}
      ref={slider}
      data-test="InstructionCarosel"
      onSwiper={setButtonStatus}
      onSlideChange={setButtonStatus}
    >
      {slides}
    </Swiper>
    <Pagination
      disabledButton={disabledButton}
      slideNext={() => {
        slider.current?.swiper.slideTo(slider.current?.swiper.snapIndex + 1)
      }}
      slidePrev={() => {
        slider.current?.swiper.slideTo(slider.current?.swiper.snapIndex - 1)
      }}
      paginationItems={pagination}
      handleMoveMainSlider={handleMoveMainSlider}
      snapIndex={snapIndex}
      onHide={onHide}
    />
  </div>
}
